import { render, staticRenderFns } from "./InfoTranparent.vue?vue&type=template&id=28d14508"
import script from "./InfoTranparent.vue?vue&type=script&lang=js"
export * from "./InfoTranparent.vue?vue&type=script&lang=js"
import style0 from "./InfoTranparent.vue?vue&type=style&index=0&id=28d14508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports